import { createInjectionContext } from '~kui/utils/createInjectionContext';

export interface UnifiedPublicLoaderContext {
  /**
   * True once the client-side intro is actually running and hiding the content. Stays false
   * on the server, during hydration, and on returning visits, so the content renders visible
   * by default (crawlable, works without JS) and is only hidden while the intro animates.
   */
  loaderActive: Ref<boolean>;
  loaderComplete: Ref<boolean>;
  loaderGone: Ref<boolean>;
  navRef: Ref<HTMLElement | null>;
  /**
   * The public nav's logo, which the intro flies its own logo into. Registered by the nav itself
   * rather than looked up by id, because a page can draw the nav more than once; the first one
   * mounted keeps it.
   */
  logoRef: Ref<Element | null>;
}

const { provideContext, useContext } = createInjectionContext<UnifiedPublicLoaderContext>('unifiedPublicLoader');

export const provideUnifiedPublicLoader = () => {
  const loaderActive = ref(false);
  const loaderComplete = ref(false);
  const loaderGone = ref(false);
  const navRef = ref<HTMLElement | null>(null);
  const logoRef = ref<Element | null>(null);
  return provideContext({ loaderActive, loaderComplete, loaderGone, navRef, logoRef });
};

export const useUnifiedPublicLoaderContext = () => useContext();
